import { forwardRef } from "react";
import type { ReactNode, SelectHTMLAttributes } from "react";
import clsx from "clsx";

export type NativeSelectSize = "sm" | "md";

export interface NativeSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  /** Visuelle Größe (nicht das HTML-Attribut `size`). */
  selectSize?: NativeSelectSize;
  wrapperClassName?: string;
}

/**
 * Native &lt;select&gt; mit einheitlichem iOS-Look (kein Browser-Default-Pfeil).
 */
export const NativeSelect = forwardRef<HTMLSelectElement, NativeSelectProps>(function NativeSelect(
  { className, wrapperClassName, selectSize = "md", disabled, children, ...rest },
  ref,
) {
  return (
    <div
      className={clsx(
        "eh-select",
        selectSize === "sm" && "eh-select--sm",
        disabled && "is-disabled",
        wrapperClassName,
      )}
    >
      <select
        ref={ref}
        disabled={disabled}
        className={clsx("eh-select-input", className)}
        {...rest}
      >
        {children}
      </select>
    </div>
  );
});

export interface NativeSelectFieldProps extends NativeSelectProps {
  label?: ReactNode;
  hint?: ReactNode;
}

export function NativeSelectField({
  label,
  hint,
  id,
  className,
  wrapperClassName,
  ...rest
}: NativeSelectFieldProps) {
  return (
    <label className={clsx("block space-y-1", className)} htmlFor={id}>
      {label ? <span className="eh-label mb-0">{label}</span> : null}
      <NativeSelect id={id} wrapperClassName={wrapperClassName} {...rest} />
      {hint ? <p className="text-xs text-label-secondary">{hint}</p> : null}
    </label>
  );
}
